import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  @Input() isLoggedIn: boolean = false;
         isDropdownVisible = false;
       constructor(public keycloakService: KeycloakService, public router: Router){

       }
       
        
       
         async ngOnInit() {
           this.isLoggedIn = await this.keycloakService.isLoggedIn();
         }

         navigateToHome() {
          this.router.navigate(['/']).then(() => {
            setTimeout(() => {
              const contactSection = document.getElementById('contact');
              if (contactSection) {
                contactSection.scrollIntoView({ behavior: 'smooth' });
              }
            }, 500); // Delay to ensure page loads before scrolling
          });
        }
}
